import $ from 'jquery';
import 'jquery.inputmask';

$('.js-phone-input').inputmask({
    mask: '+7 (999) 999-99-99',
    placeholder: '_',
    clearMaskOnLostFocus: false,
});